// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__2ajNT","SidebarButton":"Sidebar_SidebarButton__ypb0t"};